import styled, { css } from "styled-components";

import { PageSection } from "../../components/layout/layout-styles";
import { Heading as HeadingStyles } from "../../components/common/Typography/type-styles";
import { breakpoints, fontFamily, colors, sectionRhythm } from "../../../theme";

export const Section = styled(PageSection)`
  background-color: ${(props) =>
    props.bgColor ? props.bgColor : colors.white};
`;

export const Heading = styled(HeadingStyles).attrs({ as: "h2" })``;

export const ProjectList = styled.div`
  width: 94%;
  margin: 0 auto;
  margin-top: ${sectionRhythm.paddingY.mobile}px;
  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    margin-top: ${sectionRhythm.paddingY.desktop}px;
  }
`;

export const ProjectCoverSection = styled.div`
  position: relative;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    ${(props) =>
      props.isAlternate
        ? css`
            margin-left: 70px;
          `
        : css`
            margin-right: 70px;
          `}
  }

  @media only screen and (min-width: 1400px) {
    ${(props) =>
      props.isAlternate
        ? css`
            margin-left: 100px;
          `
        : css`
            margin-right: 100px;
          `}
  }
  @media only screen and (min-width: 1800px) {
    ${(props) =>
      props.isAlternate
        ? css`
            margin-left: 150px;
          `
        : css`
            margin-right: 150px;
          `}
  }
`;

export const ProjectInfoSection = styled.div`
  margin-top: 2rem;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    margin-top: 0;
  }
`;

export const ProjectMetaText = styled.span`
  font-size: 12px;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 14px;
  }
`;

export const ProjectRoles = styled.span`
  font-size: 12px;
  margin-block: 1rem 2rem;
  display: block;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 14px;
    margin-block: 1rem 2rem;
  }
`;

export const ProjectHeading = styled.h3`
  margin-block: 6px;
  font-family: ${fontFamily.bold};
  @media only screen and (min-width: ${breakpoints.tablet}) {
    width: 400px;
    font-size: 24px;
  }
`;

export const CoverContainer = styled.div`
  width: 100%;
  aspect-ratio: 3 / 2;
  border: 4px solid white;
  border-radius: 6px !important;
  overflow: hidden;
  box-sizing: border-box;
  background-color: ${colors.white};
  box-shadow: ${colors.shadow.card};

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media only screen and (min-width: ${breakpoints.tablet}) {
    width: clamp(400px, 28vw, 500px);
  }
`;

export const ProjectCardContainer = styled.div`
  background-color: ${(props) => props.bgColor};
  margin-block: 12px;
  width: 100%;
  padding: 30px 24px;
  border-radius: 12px;
  box-sizing: border-box;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    display: flex;
    flex-direction: ${(props) => (props.isAlternate ? "row-reverse" : "row")};
    align-items: flex-start;
    justify-content: center;
    padding: 80px 36px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
  }
`;
